/**
 * Created by henian.xu on 2019/11/18.
 *
 */
import { VueConstructor } from 'vue';
import Moment from 'dayjs';
import { fileSize, filterNumber, GlobalVar, isArray, isDef, isObject, isString } from '@vmf/shared';

Moment.extend(require('dayjs/plugin/duration'));

export default (vue: VueConstructor) => {
    vue.filter('moment', (value: string | number, format: string = 'YYYY-MM-DD') => {
        if (!value) return '';
        return Moment(value).format(format);
    });
    vue.filter('number', (value: string | number = 0, length: number = 2, strict: boolean = true) => {
        const res = filterNumber(value, length, strict);
        return strict ? res : +res;
    });
    vue.filter('price', (value: string | number = 0, length: number = 0, strict: boolean) => {
        const amountFormat = `${GlobalVar.moduleConfig.amountFormat}`;
        const signStrict = amountFormat.charAt(0) !== '+';
        const arr = amountFormat.split('.');
        const len = arr.length < 2 ? 0 : arr[1].length;
        return filterNumber(value, length || len, isDef(strict) ? strict : signStrict);
    });
    /**
     * imgCropping
     * mini: 100
     * small: 200
     * little: 375
     * normal: 750
     * big: 900
     * more: 1200
     * super: 1920
     */
    vue.filter('imgCropping', (value: string, params: { [k: string]: any }) => {
        value += '';
        const { moduleConfig: { imgCropping } = {} as any } = GlobalVar;
        if (!value || !imgCropping || !params) return value;
        const imgCroppingList = isArray(imgCropping) ? imgCropping : [imgCropping];
        const available = imgCroppingList.some(val => isString(val) && value.indexOf(val) === 0);
        // console.log(available, params);
        if (!available) return value;
        if (params && isString(params)) return `${value}_${params}`;
        if (params && isObject(params)) {
            // doc: https://help.aliyun.com/document_detail/44688.html?spm=a2c4g.11186623.6.1372.11313168wqiX8s
            const keyMap: { [k: string]: string } = {
                mode: 'm', // lfit、mfit、fill、pad、fixed，默认为 lfit。
                width: 'w',
                height: 'h',
                long: 'l',
                short: 's',
                limit: 'limit',
                color: 'color',
            };
            const query = Object.entries(params)
                .reduce(
                    (pre, [key, val]) => {
                        const k = keyMap[key];
                        if (k) pre.push(`${k}_${val}`);
                        return pre;
                    },
                    ['image/resize'],
                )
                .join(',');
            const fn = '?x-oss-process=';
            return `${value}${fn}${query}`;
        }
        return `${value}_normal`;
    });
    vue.filter('fileSize', (value: string | number = 0, format: string, isUpperCase: boolean = false) => {
        return fileSize(value, format as any, isUpperCase);
    });
    vue.filter('moneyFormat', (value: string | number = 0) => {
        let val = value;
        if (val === 0) val = '0';
        return `${val || ''}`.replace(/(?<!\.\d*)(\d)(?=(\d{3})+($|\.))/g, '$1,');
    });
};
